// extracted by mini-css-extract-plugin
module.exports = {"Purchase":"Purchase_Purchase__O5ew4"};